import React from "react";
import { useNavigate } from "react-router-dom";
import "./WelcomeModal.css";
import avatarImg from "../../images/shapes/Profile_Logo 1.png";

const LogoutModal = ({ user, onClose }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear auth data (example)
    localStorage.clear();
    onClose();
    navigate("/work-wit-tcuk");
  };

  return (
    <div className="modal-overlay1">
      <div className="modal-card1">

        {/* Close Button */}
        {/* <button className="modal-close1" onClick={onClose}>
          ✕
        </button> */}

        {/* Text */}
        <h2 className="modal-title1">
          {/* Are you sure you want to log out, {user.firstName}? */}
          {user.firstName}! Your session will end if you logout.
        </h2>

        {/* Buttons */}
        <div className="modal-btn-group1">
          <button className="modal-cancel-btn1" onClick={onClose}>
            Cancel
          </button>
          <button className="modal-logout-btn1" onClick={handleLogout}>
            Logout
          </button>
        </div>

      </div>
    </div>
  );
};

export default LogoutModal;
